import { RESET, LOGRADOUROS_LIST } from '../actions/Events';

export default function (state = {}, action) {
  switch (action.type) {
    case LOGRADOUROS_LIST:
      return { ...state, results: action.payload }

    case RESET:
      return {}

    default:
      return state
  }
}